import styled from 'styled-components'

const Message = styled.div`
  margin-bottom: 65px;
`

const Banner = styled.div`
  margin: 30px 20px 15px 20px;
`

const BuyToday = styled.div`
  padding: 10px 20px;

  > p {
    padding-top: 10px;
  }

  > h3 {
    margin-top: 0;
    border-bottom: 2px solid;
    display: inline-block;
  }

  ol {
    margin-top: 10px;
    padding-left: 20px;
    counter-reset: item;
    list-style: disc;
  }

  ol > li {
    list-style-type: disc;
    padding-bottom: 10px;

    @media screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].xs}) {
      margin-left: 0;
    }
  }

  ol > li::before {
    display: inline-block;
    padding-right: 10px;
    font-weight: bold;
    text-align: right;
  }

  a {
    color: ${props => props.theme.color.palette['brand-1']};
    text-decoration: underline;

    &:hover {
      color: ${props => props.theme.color.palette['brand-1-light']};
    }
  }

  p + p {
    margin-top: 10px;
  }
`

const Terms = styled.li`
  color: ${props => props.theme.color.monochrome.dark};
`

const Skeleton = styled.div`
  padding: 30px 10px;
`

const TermsLink = styled.a`
  font-display: swap;
  font-weight: ${props => props.theme.font.weight.bold};
`

const CreditOptions = styled.div`
  ol {
    list-style-type: disc;
    margin-bottom: 16px;
  }

  li {
    margin: -5px;
  }

  ol > li {
    padding-bottom: 4px;
  }
`

export { Message, Banner, BuyToday, Terms, Skeleton, TermsLink, CreditOptions }
